import type { AnnouncementInput } from "@/types/api";

export type AnnouncementTarget = "all" | "one";

export interface AnnouncementDraft {
  title: string;
  body: string;
  target: AnnouncementTarget;
  telegramUserId: string;
}

export type AnnouncementErrors = Partial<Record<"title" | "body" | "telegramId", string>>;

/**
 * Backend `CreateAnnouncementDto` bilan bir xil chegaralar: formani shu
 * yerda to'xtatish serverga borib VALIDATION_FAILED olishdan tushunarliroq.
 * Qaytadigan qiymatlar — lug'at kalitlari.
 */
export function validateAnnouncement(draft: AnnouncementDraft): AnnouncementErrors {
  const errors: AnnouncementErrors = {};
  const title = draft.title.trim();
  const body = draft.body.trim();
  if (title.length < 1 || title.length > 200) errors.title = "announcements.validation.title";
  if (body.length < 1 || body.length > 2000) errors.body = "announcements.validation.body";
  if (draft.target === "one" && !/^\d{1,20}$/.test(draft.telegramUserId.trim())) {
    errors.telegramId = "announcements.validation.telegramId";
  }
  return errors;
}

export function toAnnouncementInput(draft: AnnouncementDraft): AnnouncementInput {
  return {
    title: draft.title.trim(),
    body: draft.body.trim(),
    ...(draft.target === "one" ? { telegramUserId: draft.telegramUserId.trim() } : {}),
  };
}
